import type { Variants } from 'framer-motion'

export const peel: Variants = {
  back: { rotateX: 0 },
  mid: {
    rotateX: 80,
    transition: { duration: 0.2, ease: 'easeIn' },
  },
  front: {
    rotateX: 0,
    transition: { duration: 0.2, delay: 0.2, ease: 'easeOut' },
  },
}
